<div class="label-icon-container">
  {{ label | translate }}
  @if (iconSetting && iconSetting.tooltip && iconSetting.tooltip.length > 0) {
    <mat-icon style="opacity: 0.5;"
              [fontSet]="'material-symbols-outlined'" [matTooltip]="iconSetting.tooltip | translate" [matTooltipShowDelay]="500">
      {{ iconSetting.icon }}
    </mat-icon>
  }
</div>
